import { ShurikenIcon } from './ShurikenIcon';

/**
 * author: Michael Richins
 * id 70BBF348-E5D1-4C4C-AD93-17246A78DE13
 * name shuriken
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shuriken.svg
 * tags
 */
export const NinjaStarIcon = ShurikenIcon;
export default NinjaStarIcon